import { useEffect, useState } from 'react';
import { PageTemplate } from '@ui/templates';
import { InDeveloping } from '@@/common/components/in-developing';
import styles from './index.module.sass';
import { Card } from '@ui/card';
import { PriceCard } from '@@/mixing/components/price-card';
import { ChartCard } from '@@/mixing/components/chart-card';
import { ProgressCard } from '@@/mixing/components/progress-card/index.component';
import { AnalyticsMixingData } from '@@/mixing/ts/analytic.types';
import { useStore } from 'effector-react';
import {
  $analyticData,
  $analyticDataLoading,
  fetchMixingAnalitycDataFx,
  // updateAnalyticData,
} from '@widgets/analytics/model';
// import { DiContainer } from '@@/di/di-container';
// import { SimpleMixingService } from '@@/mixing/services/simple-mixing.service';
// import { AnalyticsMixingService } from '@@/mixing/services/analytics-mixing.service';
import { Button } from '@consta/uikit/Button';
import { formatPrice as fp } from '@/modules/common/utils/price-formatters.util';
import { default as exchangeIcon } from '@/modules/common/icons/exchange.icon.svg';
import { default as arrowIcon } from '@/modules/common/icons/arrow.icon.svg';
import { default as spicaIcon } from '@/modules/common/icons/spica.icon.svg';
import { default as priceIcon } from '@/modules/common/icons/price.icon.svg';
import logisticsIcon from '../../images/logistics.svg';
import { Loader } from '@ui/loader';
import React from 'react';
import { ProgressWidget } from '../../components/progress-widget';
import { MixingByParamsModal } from '../../components/mixing-by-params-modal';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ButtonPrimary } from '@/shared/ui/button';
import { WarehousePriceModal } from '../../components/warehouse-price-modal';
import { ProfitDataModal } from '../../components/profit-data-modal';
import { OffersListModal } from '../../../common/components/offers-list-modal';
import { BuyerWidget } from '../../components/buyer-widget';
import classNames from 'classnames';
import {
  ISearchByParams,
  useManualMixing,
} from '../../components/mixing-by-params-modal/hooks';
import { PriceCurrentCard } from '../../components/price-current-card';
import { ActivesModal } from '../../components/actives-modal';
import { $activeBuyer } from '@/modules/seller-account/store/buyers.store';
import {
  $activesModalOpen,
  $paramsModalOpen,
  setActivesModalOpen,
  setParamsModalOpen,
} from '../../store/analytical-mixing.store';

// const analyticsMixingService = DiContainer.get(AnalyticsMixingService);
//
// analyticsMixingService.getData().then((d) => {
//   updateAnalyticData(d);
// });
fetchMixingAnalitycDataFx();

export function MixingPage() {
  const navigate = useNavigate();
  const data = useStore($analyticData);
  const dataLoadingStatus = useStore($analyticDataLoading);
  const paramsModalOpen = useStore($paramsModalOpen);
  const [profitDataModalVisible, setProfitDataModalVisible] = useState(false);
  const [offersListModalVisible, setOffersListModalVisible] = useState(false);
  const [eventTrigger, setEventTrigger] = useState(0);

  const {
    value: modalState,
    initialState,
    setValue,
    setStores,
    setPermissibleVariation,
    setGluten,
    setIdk,
    setProtein,
    setHumidity,
    setNatura,
    setFallingNumber,
    setTemperature,
    setInitialState,
  } = useManualMixing([]);

  const [params] = useSearchParams();
  // useEffect(() => {
  //   const searchModalState = params.get('search');
  //   if (searchModalState) setParamsModalOpen({ payload: true});
  // }, []);

  useEffect(() => {
    const modalStateFromLocalStorage = localStorage.getItem('searchModalState');
    if (modalStateFromLocalStorage) {
      const parsedState: ISearchByParams = JSON.parse(modalStateFromLocalStorage);
      //setStores(parsedState.stores);searchModalState
      setValue({ ...parsedState, stores: modalState?.stores });
    }
  }, []);

  useEffect(() => {
    if (eventTrigger > 0) {
      localStorage.setItem('searchModalState', JSON.stringify({ ...modalState }));
    }
  }, [eventTrigger]);

  // console.log(dataLoadingStatus)

  return (
    <PageTemplate header="Аналитическое миксование пшеницы" className={styles.root}>
      {/*<InDeveloping />*/}
      {!data ? (
        <Loader />
      ) : (
        <div className={styles.cardsBlock}>
          <div className={styles.priceCards}>
            <PriceCurrentCard
              loading={dataLoadingStatus.loading}
              tonPrice={`${data?.cost_without_mixing?.toLocaleString('RU-ru', {
                maximumFractionDigits: 0,
              })} ₽`}
              onButtonClick={() => navigate('/best-prices')}
              className={styles.fixedW}
            />
            <PriceCard
              className={classNames(styles.minHeightBlock, styles.fixedW)}
              icon={logisticsIcon}
              price={data?.netto_price ? Math.round(data?.netto_price) : 0}
              description="стоимость ваших складов с учетом логистики (НЕТТО)"
              loading={dataLoadingStatus.loading}
              button={
                <ButtonPrimary
                  label="управление логистикой"
                  className={styles.logisticsButton}
                  onClick={() => navigate('/mixing/logistics')}
                />
              }
            />
            {/* <PriceCard
              // market={data?.market}
              icon={spicaIcon}
              button={
                <ButtonPrimary
                  label="показать расценки покупателей"
                  className={styles.button}
                  onClick={() => setOffersListModalVisible(true)}
                />
              }
              // price={data?.market?.price || 0}
              //header={data?.market?.date || ''}
              // isTonPrice={true}
              description="рыночная стоимость пшеницы"
              className={styles.priceBlock}
            /> */}
            <PriceCard
              icon={arrowIcon}
              className={`${styles.minHeightBlock} ${styles.gradientBg} ${styles.fixedW}`}
              price={
                data?.cost_using_mixing?.price.toLocaleString('ru', {
                  maximumFractionDigits: 0,
                }) || 0
              }
              // header={`выгода от миксования:<br>
              // <b>${fp(data?.cost_using_mixing?.benefit || 0)} ₽</b>`}
              loading={dataLoadingStatus.loading}
              headerStyle={styles.benefit}
              description={
                <span>
                  стоимость ваших складов <br /> с использованием миксования
                </span>
              }
              profit={data?.cost_using_mixing?.price - data?.cost_without_mixing}
              button={
                <ButtonPrimary
                  label="показать варианты"
                  className={styles.profitButton}
                  onClick={() => navigate('/mixing/recipes-new')}
                />
              }
            />
          </div>

          <ChartCard className={styles.chart} data={data}></ChartCard>

          {data ? (
            // <ProgressCard
            //   className={styles.chart}
            //   stocks={data.warehouses}
            // ></ProgressCard>
            <div className={classNames(styles.widgetsWrap, styles.fixedHeightLine)}>
              <ProgressWidget data={data.warehouses} />
              <BuyerWidget showBuyersFn={() => setOffersListModalVisible(true)} />
            </div>
          ) : (
            ''
          )}

          <ProfitDataModal
            visible={profitDataModalVisible}
            setVisible={setProfitDataModalVisible}
            handler={({
              tons,
              recipesCount,
              mixAlgo,
            }: {
              tons: number;
              recipesCount: number;
              mixAlgo: number;
            }): void => {
              navigate(
                `/mixing/recipes?tons=${tons}&recipes_count=${recipesCount}&mix_algo=${mixAlgo}`,
              );
              setProfitDataModalVisible(false);
            }}
          />

          {/* <OffersListModal
            visible={offersListModalVisible}
            setVisible={setOffersListModalVisible}
          /> */}

          {/* {true && (
            <MixingByParamsModal
              modalState={modalState}
              setStores={setStores}
              setPermissibleVariation={setPermissibleVariation}
              setGluten={setGluten}
              setIdk={setIdk}
              setProtein={setProtein}
              setHumidity={setHumidity}
              setNatura={setNatura}
              setFallingNumber={setFallingNumber}
              setTemperature={setTemperature}
              setInitialState={setInitialState}
              onClose={() => setParamsModalOpen({ payload: false })}
              setEventTrigger={() => setEventTrigger(eventTrigger + 1)}
            />
          )} */}

          {/* <div className={styles.buttons}>
            <Button
              onClick={() => {
                // setProfitDataModalVisible(true);
                navigate('/mixing/recipes');
              }}
              className={styles.button}
              label={`получить "рецепт" миксования`}
            />
            <Button
              onClick={() => setParamsModalOpen(true)}
              className={styles.secondaryButton}
              label={`поиск зерна по заданным параметрам`}
              view="secondary"
            />
          </div> */}
        </div>
      )}
    </PageTemplate>
  );
}
